import store from '@/plugins/vuex'

const routes = [
  {
    path: '/artist/content-id/overview',
    name: 'Content ID Overview Artist',
    component: () =>
      import(/* webpackChunkName: 'content-id-overview-artist' */ './views/Overview.vue')
  },
  {
    path: '/artist/content-id/clients',
    name: 'Content ID Clients Artist',
    component: () =>
        import(/* webpackChunkName: 'content-id-clients-artist' */ './views/Clients.vue')
  }
]

export default routes
